/**
 * PCC cluster — Wave 4 deep Q&A (service × destination/city × intent).
 * Deterministic, price-free, self-contained answers for AI answer engines.
 */
import { PCC_SERVICES, PCC_CITIES, PCC_DESTINATIONS } from "@/data/pcc";
import { expandDeep, deepAsOf, type DeepAxis } from "@/data/_qa/deep-expander";
import type { PccQA } from "./questions-500";

const AS_OF = deepAsOf(
  "สิงหาคม 2569",
  "ระเบียบของกองทะเบียนประวัติอาชญากร สำนักงานตำรวจแห่งชาติ และข้อกำหนดของปลายทางเปลี่ยนได้ ควรยืนยันกับหน่วยงานก่อนยื่นทุกครั้ง",
);

const INTENTS: DeepAxis[] = [
  { slug: "thai-applicant", th: "คนไทยที่ยื่นขอเอง" },
  { slug: "foreigner-in-th", th: "ชาวต่างชาติที่พำนักในไทย" },
  { slug: "abroad", th: "ผู้ที่อยู่ต่างประเทศและมอบอำนาจให้ดำเนินการ" },
  { slug: "employer", th: "นายจ้างหรือฝ่ายบุคคลที่ตรวจประวัติพนักงาน" },
  { slug: "urgent", th: "ผู้ที่มีกำหนดยื่นเอกสารกระชั้น" },
];

const SECONDARY: DeepAxis[] = [
  ...PCC_DESTINATIONS.map((d) => ({ slug: `dest-${d.slug}`, th: `การใช้ที่${d.nameTh}`, en: d.nameEn, note: d.note })),
  ...PCC_CITIES.map((c) => ({ slug: `city-${c.slug}`, th: `ผู้ยื่นในพื้นที่${c.nameTh}`, en: c.nameEn })),
];

export const PCC_QA_WAVE4: PccQA[] = expandDeep<PccQA["cluster"]>({
  prefix: "pcc-w4",
  asOf: AS_OF,
  authorityTh: "กองทะเบียนประวัติอาชญากรหรือหน่วยงานปลายทางผู้พิจารณา",
  clusterTh: "งานขอใบตรวจประวัติอาชญากรรม",
  primary: PCC_SERVICES.map((s) => ({ slug: s.slug, th: s.nameTh, en: s.nameEn, note: `เหมาะกับ ${s.audience.slice(0, 2).join(" / ")} และมักถูกยอมรับโดย ${s.acceptedBy.slice(0, 3).join(" / ")}` })),
  secondary: SECONDARY,
  intents: INTENTS,
  clusters: { documents: "documents", process: "process", risk: "legal", location: "location" },
  cap: 430,
});
